import React from 'react';
import '../style.css';
import TopHeader from '../TopHeader';
import Navbar from '../Navbar';
import ScrollToTop from '../ScrollToTop';
import Footer from '../Footer';
import QueryForm from '../Queryform';

const Contact = () => {
  return (
    <>
    <TopHeader/>
    <Navbar/>
    <div className="contactus-container">
      <h1 className="contactus-title">Contact Us</h1>

      <p className="contactus-intro">We’re Here to Help You Travel Better</p>
      <p className="contactus-text">Have questions or want to book a package? Just reach out to us:</p>

      <div className="contactus-info">
        <p><span role="img" aria-label="location"></span> <strong>Trip and Drop Travels Pvt. Ltd.</strong></p>
        <p><strong>Address:</strong> H-35, Sant Nagar Extension, Tilak Nagar, New Delhi – 110018</p>
        <p><span role="img" aria-label="phone"></span> <strong>Phone:</strong> +91 9999116868</p>
        <p><span role="img" aria-label="email"></span> <strong>Email:</strong> info@tripanddrop.com</p>
      </div>
    </div>

    <div class='get-touch'> 
  
   <QueryForm/>
     <div class='map'>
   <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.4293241997243!2d77.09111109999999!3d28.646861099999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb0a4b6549860ef1%3A0xbab220e01e65b41f!2sTrip%20and%20Drop%20Travels%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1749367138786!5m2!1sen!2sin" width="650" height="500"  allowfullscreen="" loading="lazy" title="Trip and Drop" referrerpolicy="no-referrer-when-downgrade"></iframe>
     </div>
     </div>

      <ScrollToTop/>
    <Footer/>

    </>

  
  );
};

export default Contact;
